export const WHATSAPP_URL =
  'https://wa.me/16513872889?text=Hola%20Cenia%2C%20quiero%20reservar%20mi%20lugar%20en%20el%20seminario'

export const MAPS_URL =
  'https://maps.google.com/?q=3033+Excelsior+Blvd+Suite+100+Minneapolis+MN+55416'

export const MAPS_EMBED_URL =
  'https://www.google.com/maps?q=3033+Excelsior+Blvd+Suite+100+Minneapolis+MN+55416&output=embed'

export const ADDRESS = '3033 Excelsior Blvd, Suite #100, Minneapolis, MN 55416'

export const CENIA_PHOTO = 'https://i.imgur.com/dUQjlVV.jpg'

export type LearnItem = {
  icon: 'check-circle' | 'file-text' | 'hand-coins' | 'key-round'
  title: string
  description: string
}

export const learnItems: LearnItem[] = [
  {
    icon: 'check-circle',
    title: '¿Califico para comprar?',
    description: 'Descubre si puedes comprar casa con tu situación actual.',
  },
  {
    icon: 'file-text',
    title: 'Documentos que necesitas',
    description: 'SSN, ITIN o dueño de negocio, te explicamos todo.',
  },
  {
    icon: 'hand-coins',
    title: 'Programas de asistencia',
    description: 'Conoce los programas disponibles en Minnesota para compradores.',
  },
  {
    icon: 'key-round',
    title: 'Pasos hacia tus llaves',
    description: 'El proceso completo desde la consulta hasta el cierre.',
  },
]

export const requirements: string[] = [
  'Solo necesitas 2 años de historial laboral',
  'Historial de impuestos',
  'Ganas de aprender y tomar acción',
]

export const stats: { value: string; label: string }[] = [
  { value: '21+', label: 'Años' },
  { value: '1,000+', label: 'Casas' },
  { value: 'Hablo', label: 'Español' },
]
